import Repository from "@shared/services/api/abstracts/Repository";
import { type UserBasedVenueEmployment } from "../types/venue-employments";

export default class UserBasedVenueEmploymentRepository extends Repository<UserBasedVenueEmployment> {
  public readonly repositoryName = "UserBasedVenueEmploymentRepository";

  public readonly endpoint = "api/user/venues/employments";
}
